import { format, parseISO, isValid } from "date-fns";
import { de } from "date-fns/locale";

export const useDate = () => {
    return (dateString) => {
        const date = parseISO(dateString);
        if (isValid(date)) {
            const formattedDate = format(date, "dd.MM.yyyy", { locale: de });
            return formattedDate;
        } else return "";
    };
};

export const useTime = () => {
    return (dateString) => {
        const date = parseISO(dateString);
        return format(date, "p", { locale: de });
    };
};

export const useCurrency = () => {
    return (number) => {
        if (!number < number <= 0) {
            return " - ";
        }

        return parseFloat(number).toFixed(2).replace(".", ",") + " €";
    };
};
